import { get } from 'lodash-es';
import { message } from '@fuxi/eevee-ui';
import { handleLogout, safeToLogin, isCanceledError } from 'common/utils';
import { AxiosResponse } from 'axios';

export function errorHandler(error: any) {
  // Ignore error when request is canceled by user:
  if (isCanceledError(error)) return Promise.reject(error);

  const status: number = get(error, 'response.status', 0);
  const code: number = get(error, 'response.data.code', 0);
  const msg = get(error, 'response.data.message') || get(error, 'response.data.msg', '服务端异常');

  // http级别错误处理
  // 处理401
  if (error?.config?.signal?.reason === 'ABANDONED_BY_USER') {
    return 'ABANDONED_BY_USER';
  }

  if (status === 401) {
    handleLogout();
    safeToLogin();
  } else {
    const msg = get(error, 'response.data.message', get(error, 'response.data.msg', '服务端异常'));
    message.error(msg);
  }

  return Promise.reject({ status, code, msg });
}

export function responseHandler(response: AxiosResponse & { code?: number; message?: string }): ExtendAxioResponse {
  const data = get(response, 'data.data', response.data);
  const code = get(response, 'data.code', response?.code);
  const message = get(response, 'data.message', response?.message);
  if (code === 401) {
    message.error('请先登录');
    //用户token过期，需要重新登录
    handleLogout();
    safeToLogin();
  }

  return { ...response, data, code, message };
}
